import React, { useState, useEffect } from "react";
import { db, storage } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import {  ref,uploadBytes, getDownloadURL } from "firebase/storage";
import { onAuthStateChanged } from "firebase/auth";

import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";
const AddTeamMember = () => {
  const [name, setName] = useState("");
  const [lname, setLName] = useState("");
  const [role, setRole] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [department, setDepartment] = useState("")
  const [url, setUrl] = useState("https://portal.gnbank.net")
  const [email, setEmail] = useState("support@gnbank.net")
  const [Telephone, setTelephone] =useState("7736242000")

const navigate = useNavigate("/")

  const [user, setUser] = useState(null)

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        console.log("User is logged in:", currentUser.email);
      } else {
        setUser(null);
        console.log("No user is logged in");

        // navigate("/")


      }
    });

    // Cleanup on unmount
    return () => unsubscribe();
  }, []);



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (image) {
    const imageRef = ref(storage, `teamMembers/${image.name}`);
      await uploadBytes(imageRef, image);
      const imageUrl = await getDownloadURL(imageRef);

      await addDoc(collection(db, "teamMembers"), {
        name,
        lname,
        role,
        description,
        imageUrl,
        department,
        email,
        Telephone,
        url
      });

      setName("");
      setRole("");
      setDescription("");
      setLName("");
      setImage(null);
      alert("Team member added successfully!");
    } else {
      alert("Please upload an image!");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h1>Add Team Member</h1>
      <input
        type="text"
        placeholder="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
      />

<input
        type="text"
        placeholder="Last Name"
        value={lname}
        onChange={(e) => setLName(e.target.value)}
        required
      />
      <input
        type="text"
        placeholder="Role"
        value={role}
        onChange={(e) => setRole(e.target.value)}
        required
      />
        <input
        type="text"
        placeholder="Department"
        value={department}
        onChange={(e) => setDepartment(e.target.value)}
        required
      />
      <textarea
        placeholder="Description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        required
      />
      <input type="file" onChange={(e) => setImage(e.target.files[0])} required />
      <button type="submit">Add Member</button>
    </form>
  );
};

export default AddTeamMember;
